import React, { useEffect, useMemo } from "react";
import styles from "./index.module.css";
import MultiselectDropdown from "../MultiselectDropdown";
import { categorySteps } from "../../../utils/constant";
import { useState } from "react";
import StackedBarChart from "../StackedBarChart";
import { Head, Row } from "../TableheadAndRow";
import { useDispatch, useSelector } from "react-redux";
import { fetchPPCTrends } from "../../../store/slices/analytics/analytics.slice";
import { useNavigate } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import { getSource, filterAnalyticsLocationsByOrg } from "../../../utils/helpers";

const AnalyticsCategory = () => {
  const dispatch = useDispatch();
  const ppcTrends = useSelector((store) => store.analytics.ppcTrends);
  const { location: locationSteps, source } = useSelector(
    (store) => store.constant
  );
  const organizationId = useSelector((store) => store.user.organizationId);
  
  const filteredLocationSteps = useMemo(() => {
    return filterAnalyticsLocationsByOrg(locationSteps, organizationId);
  }, [locationSteps, organizationId]);

  const [graphData, setGraphData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [tableHeaders, setTableHeaders] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState(categorySteps);
  const [selectedLocations, setSelectedLocations] = useState(filteredLocationSteps || []);
  const navigate = useNavigate();

  useEffect(() => {
    if (filteredLocationSteps && filteredLocationSteps.length > 0) {
      setSelectedLocations(filteredLocationSteps);
    }
  }, [filteredLocationSteps]);

  useEffect(() => {
    dispatch(fetchPPCTrends({ selectedLocations, source }));
  }, [selectedLocations, source]);

  useEffect(() => {
    let data = [],
      headers = ["Category"],
      maxRank = 0;

    for (let i = 0; i < ppcTrends?.length; i++) {
      data.push({
        category: ppcTrends[i]?.category,
        cheapest: ppcTrends[i]?.cheapest_count,
        midrange: ppcTrends[i]?.midrange_count,
        expensive: ppcTrends[i]?.expensive_count,
      });

      let last = 0;
      for (
        let j = 0;
        j < ppcTrends[i]?.pricerank_wise_product_count?.length;
        j++
      ) {
        if (j == 0) {
        }
        //  data[i].cheapest = parseInt(ppcTrends[i]?.cheapest_count);
        else {
          if (parseInt(ppcTrends[i]?.pricerank_wise_product_count[j]) != 0) {
            last = parseInt(ppcTrends[i]?.pricerank_wise_product_count[j]);
            if (j > maxRank) maxRank = j;
          }

          // data[i].midrange+=parseInt(ppcTrends[i]?.pricerank_wise_product_count[j]);
        }
      }

      // data[i].midrange -= last;
      // data[i].expensive = last;
    }

    let finalData = [];
    for (let i = 0; i < data?.length; i++) {
      if (
        selectedCategories.findIndex(
          (el) => el.toLowerCase() == data[i]?.category
        ) != -1
      ) {
        finalData.push(data[i]);
      }
    }
    setGraphData(finalData);

    data = [];

    for (let i = 0; i <= maxRank; i++) {
      headers.push("Price Rank-" + (i + 1));
    }

    for (let i = 0; i < ppcTrends?.length; i++) {
      data.push({
        category: ppcTrends[i].category,
        price_rank: [],
      });

      for (let j = 0; j <= maxRank; j++) {
        if (ppcTrends[i]?.pricerank_wise_product_count?.length <= j)
          data[i].price_rank.push(0);
        else
          data[i].price_rank?.push(
            parseInt(ppcTrends[i]?.pricerank_wise_product_count[j])
          );
      }
    }

    finalData = [];
    for (let i = 0; i < data?.length; i++) {
      if (
        selectedCategories.findIndex(
          (el) => el.toLowerCase() == data[i]?.category
        ) != -1
      ) {
        finalData.push(data[i]);
      }
    }

    setTableHeaders(headers);
    setTableData(finalData);
  }, [ppcTrends, selectedCategories]);
  const data = [
    // {
    //   name: "Apparel",
    //   cheapest: 30,
    //   midrange: 46,
    //   expensive: 70,
    // },
    {
      name: "Beauty",
      cheapest: 1,
      midrange: 3,
      expensive: 1,
    },
    {
      name: "Liquor",
      cheapest: 9,
      midrange: 0,
      expensive: 0,
    },
  ];

  const tableDataDemo = [
    // {
    //   category: "Apparel",
    //   price1: 132,
    //   price2: 36,
    //   price3: 15,
    //   price4: 13,
    //   price5: null,
    // },
    {
      category: "Beauty",
      price1: 1,
      price2: null,
      price3: 3,
      price4: null,
      price5: 1,
    },
    {
      category: "Liquor",
      price1: 9,
      price2: 0,
      price3: null,
      price4: null,
      price5: null,
    },
  ];

  const onSelectedLocationChange = (value) => {
    setSelectedLocations(value);
  };

  const onSelectedCategoryChange = (value) => {
    setSelectedCategories(value);
  };
  return (
    <div className={styles["container"]}>
      {/* Heading */}
      <div className={styles["graph"]}>
        <div className={styles["heading"]}>
          <div className={styles["titleAndPriceType"]}>
            <h3>Compare prices per category</h3>
            <div className={styles["priceType"]}>
              <span className={styles["cheapest"]}>
                <i class="bi bi-circle-fill"></i>
                <span>cheapest</span>
              </span>
              <span className={styles["midrange"]}>
                <i class="bi bi-circle-fill"></i>
                <span>midrange</span>
              </span>
              <span className={styles["expensive"]}>
                <i class="bi bi-circle-fill"></i>
                <span>expensive</span>
              </span>
            </div>
          </div>
          <div className={styles["filters"]}>
            <div className={styles["category"]}>
              <MultiselectDropdown
                steps={filteredLocationSteps}
                onChange={onSelectedLocationChange}
                name="locations"
              />
            </div>
            <div className={styles["category"]}>
              <MultiselectDropdown
                steps={categorySteps}
                onChange={onSelectedCategoryChange}
                name="category"
              />
            </div>
          </div>
        </div>

        <div className={styles["barGraph"]}>
          <StackedBarChart
            url={"/dashboard/df-products"}
            data={graphData}
            blueLabel={"cheapest"}
            greyLabel={"midrange"}
            greenLabel={"expensive"}
            type={"category"}
            location={selectedLocations}
          />
        </div>
      </div>

      {/* Table content.  */}
      <div className={styles["table"]}>
        <Head>
          {tableHeaders && tableHeaders?.map((header) => <span>{header}</span>)}
        </Head>

        {tableData.length == 0 ? (
          <div className="loader-container">
            {" "}
            <PulseLoader />{" "}
          </div>
        ) : (
          tableData.map((item, index) => (
            <Row
              islast={tableData.length - 1 == index ? true : false}
              key={index}
            >
              <span>{item.category}</span>
              {item?.price_rank?.map((el, idx) => (
                <span
                  onClick={() =>
                    navigate(
                      `/dashboard/df-products?category=${
                        item.category
                      }&pricerank=${idx + 1}&location=${selectedLocations}`
                    )
                  }
                >
                  {el || "0"}
                </span>
              ))}
            </Row>
          ))
        )}
      </div>
    </div>
  );
};

export default AnalyticsCategory;
